<template>
    <div class="c-app flex-row align-items-center">
        <CContainer>
            <CRow class="justify-content-center">
                <CCol md="8">
                    <CCardGroup>
                        <CCard class="p-4">
                            <CCardBody>
                                <CRow>
                                    <CCol md="12" class="mt-2">
                                        <h1 class="text-center mb-3">{{ i18n.login.title }}</h1>
                                        <ValidationObserver v-slot="{ invalid }" ref="form">
                                            <CForm @submit.prevent="onLogin">
                                                <ValidationProvider name="Account" rules="required" v-slot="{ valid, errors }">
                                                    <CInput
                                                        :label="i18n.login.username"
                                                        type="text"
                                                        v-model="form.account"
                                                        autocomplete="off"
                                                        :placeholder="i18n.login.username_placeholder"
                                                        :invalid-feedback="errors[0]"
                                                        :isValid="errors[0] ? false : valid ? true : null"
                                                    />
                                                </ValidationProvider>
                                                <ValidationProvider name="password" rules="required" v-slot="{ valid, errors }">
                                                    <CInput
                                                        :label="i18n.login.password"
                                                        type="password"
                                                        v-model="form.password"
                                                        :placeholder="i18n.login.password_placeholder"
                                                        autocomplete="off"
                                                        :invalid-feedback="errors[0]"
                                                        :isValid="errors[0] ? false : valid ? true : null"
                                                    />
                                                </ValidationProvider>
                                                <vue-recaptcha
                                                    ref="recaptcha"
                                                    size="invisible"
                                                    @expired="onCaptchaExpired"
                                                    sitekey="6LdiE18jAAAAAFZlsUpD8Jc0oZV_knlreLm_yf7E"
                                                />
                                                <CButton
                                                    type="submit"
                                                    size="lg"
                                                    color="info"
                                                    class="mr-2 btn-block px-4 text-white text-monospace"
                                                    :disabled="invalid"
                                                >
                                                    {{ i18n.login.login_button }}
                                                </CButton>
                                            </CForm>
                                        </ValidationObserver>
                                    </CCol>
                                </CRow>
                            </CCardBody>
                        </CCard>
                    </CCardGroup>
                </CCol>
            </CRow>
        </CContainer>
    </div>
</template>

<script>
import { mapMutations } from 'vuex';
//import store from '@/store';
import { to } from '@/utils';
import { login } from '@/api/auth';
import { VueRecaptcha } from 'vue-recaptcha';
import { getUrlProject, getUrlLang, getUrlQuery } from '@/services/check';
import { getLangString } from '@/services/lang';

export default {
    name: 'Login',
    components: { VueRecaptcha },
    data() {
        return {
            form: {
                account: '',
                password: '',
            },
            i18n: null,
        };
    },
    methods: {
        ...mapMutations('account', ['setUser', 'setToken', 'removeAllStorage']),
        async onLogin() {
            this.$refs.form.validate().then(async success => {
                if (success) {
                    //console.log(this.form);
                    let err, result;
                    [err, result] = await to(login(this.form));
                    if (err) {
                        this.$awn.warning(this.i18n.alert.login_fail);
                        return false;
                    }
                    let data = result.data;
                    this.setToken(data.token);
                    this.setUser({ empNO: data.emp_id, ad: data.user_id, userID: data.id, name: data.name, role: data.role });
                    this.$awn.success(this.i18n.alert.login_success);
                    //console.log(`/2fa-query${getUrlQuery(getUrlProject(), getUrlLang())}`);
                    this.$router.push({ path: `/2fa-query${getUrlQuery(getUrlProject(), getUrlLang())}` });
                }
            });
        },
        onCaptchaExpired() {
            this.$refs.recaptcha.reset();
        },
    },
    created() {
        this.i18n = getLangString(getUrlLang());
    },
    mounted() {
        let token = localStorage.getItem('INX.2FA.TOKEN', token);
        if (token) {
            this.$router.push({ path: `/2fa-query${getUrlQuery(getUrlProject(), getUrlLang())}` });
        } else {
            this.removeAllStorage();
        }
    },
};
</script>
